import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";

import { map } from "rxjs/operators";
import { UserForm } from "app/interfaces/user-form.interface";

const incidentsSharedUrlApi = environment.incidentsSharedUrlApi;
const incidentMySharedListUrlApi = environment.incidentMySharedListUrlApi;
const incidentMySharedOwnListUrlApi = environment.incidentMySharedOwnListUrlApi;

@Injectable()
export class SharedIncidentService {
  public user: UserForm;

  constructor(private http: HttpClient) {}

  getSharedIncidentsByIdUser(id: number) {
    return this.http
      .request("GET", `${incidentsSharedUrlApi}/` + id, {
        responseType: "json",
      })
      .pipe(map((resp: any) => resp));
  }

  shareIncident(idUser: number, idIncident: number) {
    const body = { id_user: idUser, id_incident: idIncident };
    return this.http
      .request("POST", `${incidentsSharedUrlApi}`, { body })
      .pipe(map((resp: any) => resp));
  }

  getMySharedIncidentsListByIdUser(id: number) {
    return this.http
      .request("GET", `${incidentMySharedListUrlApi}/` + id, {
        responseType: "json",
      })
      .pipe(map((resp: any) => resp));
  }

  getMySharedOwnIncidentsListByIdUser(id: number) {
    return this.http
      .request("GET", `${incidentMySharedOwnListUrlApi}/` + id, {
        responseType: "json",
      })
      .pipe(map((resp: any) => resp));
  }

  deleteMySharedIncidentById(id: number) {
    return this.http
      .request("DELETE", `${incidentsSharedUrlApi}/` + id, {
        responseType: "json",
      })
      .pipe(map((resp: any) => resp));
  }
}
